import * as Yup from 'yup'

export const createCompanySchema = Yup.object({
  name: Yup.string()
    .required('Firma adı boş bırakılamaz')
    .min(2, 'Firma adı 2 karakterden kısa olamaz')
})
